import React from "react";

const MapPinSvg = () => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="25"
				viewBox="0 0 24 25"
				fill="none"
			>
				<path
					d="M12 13.0039C13.6569 13.0039 15 11.6608 15 10.0039C15 8.34705 13.6569 7.00391 12 7.00391C10.3431 7.00391 9 8.34705 9 10.0039C9 11.6608 10.3431 13.0039 12 13.0039Z"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M19.5 10.0039C19.5 16.7539 12 22.0039 12 22.0039C12 22.0039 4.5 16.7539 4.5 10.0039C4.5 8.01478 5.29018 6.10713 6.6967 4.70061C8.10322 3.29408 10.0109 2.50391 12 2.50391C13.9891 2.50391 15.8968 3.29408 17.3033 4.70061C18.7098 6.10713 19.5 8.01478 19.5 10.0039V10.0039Z"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	);
};
export default MapPinSvg;
